import { CardsIcon, SquaresFourIcon, TableIcon } from '@phosphor-icons/react'
import type { ReactElement } from 'react'
import { SegmentedControl } from 'app/components/action-center/SegmentedControl'
import type { ListView } from 'app/types/navigation'

// Densest first: the table shows the whole list, the board a lane per stage, the card one
// person. "Card" names what the view draws; "One at a time" named how you worked it.
const OPTIONS: { id: ListView; label: string; icon: ReactElement; title: string }[] = [
  {
    id: `table`,
    label: `Table`,
    icon: <TableIcon size={14} weight="bold" />,
    title: `Sort, filter and export the whole list`,
  },
  {
    id: `board`,
    label: `Board`,
    icon: <SquaresFourIcon size={14} weight="bold" />,
    title: `Hold several conversations in flight at once`,
  },
  {
    id: `focus`,
    label: `Card`,
    icon: <CardsIcon size={14} weight="bold" />,
    title: `Work the list a person at a time`,
  },
]

export function ListViewToggle({
  views,
  current,
  onSelect,
}: {
  views: ReadonlyArray<ListView>
  current: ListView
  onSelect: (view: ListView) => void
}): ReactElement {
  return (
    <SegmentedControl
      className="shrink-0"
      options={OPTIONS.filter((option) => views.includes(option.id))}
      value={current}
      onSelect={onSelect}
    />
  )
}
